import { render, staticRenderFns } from "./InvoiceParameterHeaderForm.vue?vue&type=template&id=56d60878&"
import script from "./InvoiceParameterHeaderForm.vue?vue&type=script&lang=js&"
export * from "./InvoiceParameterHeaderForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports